export default {
    grading: {
        title: 'Grading',
        limitationInfo: 'VON HEUTIGEM GRADING-LIMIT',
        tabs: {
            submit: 'Einsenden',
            pending: 'Ausstehend',
            completed: 'Abgeschlossen'
        },
        nextRun: 'Nächster Lauf',
        credit: 'Credits',
        card: 'Karte',
        price: 'Preis',
        duration: 'Dauer',
        selectionInfo: 'Auswahl: {count} / {limit}',
        total: 'Gesamt',
        submit: 'Einsenden',
        infoTitle: 'Informationen',
        infoPoint1: 'Grading kostet den Basiswert der Seltenheit.',
        infoPoint2: 'Pro Tag können maximal 20 Karten eingesendet werden.',
        infoPoint3: 'Karten werden am nächsten Tag um 8 Uhr bewertet zurückgegeben.',
        infoPoint4: 'Die Note erhöht oder verringert den Wert deiner Karte prozentual.',
        completesAt: 'Fertig um',
        noPending: 'Keine ausstehenden Einsendungen',
        gradedAt: 'Bewertet am',
        noCompleted: 'Keine abgeschlossenen Bewertungen',
        selectCards: 'Karten auswählen',
        cancel: 'Abbrechen',
        confirmSelection: 'Auswahl bestätigen',
        basePrice: 'Basispreis',
        gradedPrice: 'Bewerteter Preis',
        finishNowFor: 'Sofort abschließen für {price}',
        finishNowToken: 'Sofort abschließen (Skip-Token)'
    },
    dashboard: {
        welcome: 'Hallo',
        pages: {
            shop: 'Shop',
            marketplace: 'Marktplatz',
            boosters: 'Booster',
            cards: 'Karten',
            collections: 'Sammeln',
            decks: 'Decks',
            trading: 'Tauschen',
            social: 'Soziales',
            gallery: 'Gallerie',
            quiz: 'Quiz',
            pokewordle: 'Wordle',
            casino: 'Casino',
            search: 'Suche',
            settings: 'Einstellungen',
            administration: 'Administration',
            grading: 'Grading',
        },
        rows: {
            shopping: 'Einkaufen',
            mystuff: 'Mein Zeug',
            discover: 'Entdecken',
            social: 'Social',
            games: 'Spiele',
            other: 'Anderes',
        }
    },
    boosters: {
        title: 'Boosterpacks',
        empty: "Du hast aktuell keine Boosterpacks.",
        buySome: 'Kaufe welche im Shop!',
        currentlyOpening: 'Öffnung läuft aktuell',
        bulkInfo: 'Vervollständige {count} Set-Sammlungen um diesen Öffner freizuschalten, du hast aktuell {have} Set-Sammlungen komplett',
        auto: 'Auto',
        skip: 'Überspringen',
        stop: 'Stop',
        cardsLeft: 'übrig',
        postedBooster: 'Booster wurde gepostet',
        share: 'Teilen',
        close: 'Schließen',
        pulledCards: 'Gezogene Karten',
    },
    gallery: {
        title: 'Gallerie',
        cards: 'Karten',
        secrets: 'Secrets',
        back: 'Zurück zu Liste',
        highlight: 'Hebe Karten in Sammlung hervor',
        search: 'Suche',
        types: {
            pokemon: 'Pokémon',
            trainer: 'Trainer',
            energy: 'Energie',
            illustration: 'Illustration',
        },
        boosters: 'Booster',
        products: 'Produkte',
    },
    collections: {
        title: 'Sammlungen',
        tabs: {
            sets: 'Sets',
            custom: 'Eigene'
        },
        bySet: 'Nach Set',
        create: 'Erstelle neue Sammlung',
        createButton: 'Erstellen',
        notifications: {
            created: 'Sammlung "{name}" erstellt!',
            defineName: 'Bitte definiere einen Namen für deine Sammlung',
        },
        collection: 'Sammlung',
        description: 'Beschreibung',
        value: 'Wert der Sammlung',
        back: 'Zurück zur Übersicht',
        backProfile: 'Zurück zum Profil',
        empty: 'In dieser Sammlung gibt es aktuell noch keine Karten',
        info: 'Karten-Info',
        sortBy: 'Sortieren nach',
        sort: 'Absteigend sortieren',
        public: 'Öffentliche Sammlung (Wird in deinem Profil angezeigt)',
        allowDuplicates: 'Erlaube Duplikate in dieser Sammlung',
        update: 'Einstellungen speichern',
        updated: 'Einstellungen gespeichert',
        dissolve: 'Willst du diese Sammlung wirklich auflösen?',
        deleteEmpty: 'Willst du diese leere Sammlung wirklich löschen?',
        legendCards: 'LEGENDEN KARTEN',
        vUnionCards: 'V-UNION KARTEN',
        cardName: 'Kartenname',
        cardAdded: 'Karte hinzugefügt am',
        settings: 'Sammlungs-Einstellungen',
        sortFields: {
            date: 'Hinzufüge-Datum',
            release: 'Karten-Veröffentlichung',
            name: 'Name',
            number: 'Kartennummer',
            pokeDex: 'Pokédex-Nummer',
        },
        dissolveButton: 'Sammlung auflösen',
        deleteButton: 'Sammlung löschen',
    },
    cardInfo: {
        name: 'Name',
        set: 'Set',
        series: 'Serie',
        artist: 'KünsterIn',
        rarity: 'Seltenheit',
        type: 'Typ',
        weakness: 'Schwäche',
        resistance: 'Resistenz',
        id: 'Karten-ID',
        showOn: 'Zeige auf',
        price: 'Dein Preis',
        value: 'Wert',
        inCollection: 'In der Sammlung',
        yes: 'Ja',
        no: 'Nein',
        created: 'Erstellt',
        addWishlist: 'Will ich',
        removeWishlist: 'Von Wunschliste entfernen',
        sell: 'Verkaufen für',
        sellX: 'Verkaufe {amount} für',
        share: 'Teilen',
        shareTitle: '{title} auf Dipocaco',
        shareMessage: 'Hab eine tolle Karte aus {set} gefunden!',
        copiedID: 'ID in Zwischenablage kopiert',
        removeFromCollection: 'Aus Sammlung entfernen',
        removeAllFromCollection: 'Alle aus Sammlung entfernen',
        setCollectionCover: 'Als Sammlungs-Cover setzen',
    },
    shop: {
        title: 'Shop',
        limitationInfo: 'VON HEUTIGEM BOOSTER-KAUF LIMIT',
        limitReached: 'LIMIT ERREICHT',
        refreshesInfo: 'Wird aktualisiert',
        wait: 'warte',
        tabs: {
            specials: 'Specials',
            sets: 'nach Set',
            decks: 'Decks',
        },
        headings: {
            collections: 'Sammlungen',
            blisters: 'Blister',
            tins: 'Dosen',
            prepareToFight: 'Mach dich bereit für den Kampf!',
        },
        items: {
            single: 'Einzelnes Boosterpack',
            single4: 'Einzelnes 4er Boosterpack',
            single5: 'Einzelnes 5er Boosterpack',
            single6: 'Einzelnes 6er Boosterpack',
            single7: 'Einzelnes 7er Boosterpack',
            single20: 'Einzelnes 20er Boosterpack',
            single25: 'Einzelnes 25er Boosterpack',
            bundle: 'Bundle mit 6 Boosterpacks',
            etb: 'TTB mit 9 Boosterpacks',
            etbWithPromo: 'TTB mit 9 Boosterpacks und der Promo-Karte "{promo}"',
            display: 'Display mit 36 Boosterpacks',
            blisterWithOne: 'Blister mit einem Boosterpack',
            blisterWithOneAndPromo: 'Blister mit einem Boosterpack und der Promokarte "{promo}"',
            blisterWithOneAndXPromo: 'Blister mit einem Boosterpack und {promoCount} Promokarten',
            blisterWithTwo: 'Blister mit zwei Boosterpacks',
            blisterWithTwoAndPromo: 'Blister mit zwei Boosterpacks und der Promokarte "{promo}"',
            blisterWithTwoAndXPromo: 'Blister mit zwei Boosterpacks und {promoCount} Promokarten',
            blisterWithThree: 'Blister mit drei Boosterpacks',
            blisterWithThreeAndPromo: 'Blister mit drei Boosterpacks und der Promokarte "{promo}"',
            blisterWithThreeAndXPromo: 'Blister mit drei Boosterpacks und {promoCount} Promokarten',
            mixedAndPromo: '{boosterCount} Boosterpacks und der Promokarte "{promo}"',
            mixedAndXPromo: '{boosterCount} Boosterpacks und {promoCount} Promokarten',
            mixedBoosterOnly: '{type} mit {boosterCount} Boosterpacks',
            ultraPremium: 'Ultra Premium Kollektion mit {boosterCount} Boosterpacks und {promoCount} Promokarten',
        },
        owned: 'GEKAUFT',
        notEnoughCredits: "Du hast nicht genügend Credits für diesen Kauf",
        cooldownActive: 'Abklingzeit aktiv',
        addedToInventory: 'Item(s) wurden deinem Inventar hinzugefügt',
        deckAlreadyOwned: 'Du besitzt dieses Deck bereits',
    },
    marketplace: {
        title: 'Marktplatz',
        tabs: {
            browse: 'Entdecken',
            yours: 'Eigene',
            create: 'Erstellen',
        },
        currentOffers: 'Aktuelle Angebote aus der Community',
        noOffers: 'Es gibt aktuell keine Angebote',
        onlyUnowned: 'Zeige nur neue',
        from: 'Ab',
        search: 'Suche',
        my: 'Meine Angebote',
        noActiveOffers: "Du hast aktuell keine Angebote",
        cardInfo: {
            name: 'Name',
            set: 'Set',
            series: 'Serie',
            artist: 'KünsterIn',
            rarity: 'Seltenheit',
            type: 'Typ',
            weakness: 'Schwäche',
            resistance: 'Resistenz',
            id: 'Karten-ID',
            showOn: 'Zeige auf',
            price: 'Dein Preis',
            value: 'Wert',
            inCollection: 'In der Sammlung',
            yes: 'Ja',
            no: 'Nein',
            created: 'Erstellt',
            delete: 'Angebot löschen',
            buy: 'Kaufe für'
        },
        create: 'Neues Angebot erstellen',
        noCards: "Du hast aktuell keine losen Karten.",
        choose: 'Wähle eine Karte, um sie auf dem Marktplatz zu verkaufen',
        info: 'Während diese Karte auf dem Marktplatz angeboten wird, wird sie aus deinem Karten-Inventar entfernt. Marktplatz-Angebote laufen nach zwei Wochen automatisch ab.',
        offer: 'Karte auf dem Marktplatz anbieten',
        cancel: 'Abbrechen',
        createOffer: 'Neues Angebot erstellen',
        notifications: {
            added: 'Angebot wurde erstellt',
            refreshed: 'Aktualisiert',
            deleted: 'Angebot wurde gelöscht',
            purchaseSuccessful: 'Kauf erfolgreich'
        },
        back: 'Zurück zum Marktplatz',
        refreshOffers: 'Angebote aktualisieren',
        price: 'Preis',
        free: 'GRATIS',
        buy: 'Kaufen',
        get: 'Holen',
        noOffersCard: 'Für diese Karte gibt es aktuell keine Angebote'
    },
    myCards: {
        heading: 'Meine Karten',
        sellDuplicates: 'Duplikate verkaufen',
        sellingDuplicates: 'Duplikate verkaufen ...',
        storeNew: 'In Sammlungen legen',
        storingNew: 'Neue Karten in Sammlung legen ...',
        clear: 'Auswahl aufheben',
        all: 'Alle auswählen',
        sellSelected: 'Auswahl verkaufen',
        putInCollection: 'In Sammlung legen ...',
        sellingSelected: 'Verkaufe Auswahl ...',
        filter: {
            heading: 'Suche / Sortieren / Filter',
            search: 'Suche ...',
            sortBy: 'Sortieren nach',
            sortPulldate: 'Zieh-Datum',
            sortName: 'Name',
            sortDex: 'Pokédex-Nummer',
            sortType: 'Typ',
            sortSupertype: 'Haupttyp',
            sortRarity: 'Seltenheit',
            sortSet: 'Set',
            sortArtwork: 'Künstler',
            sortQuantity: 'Menge',
            sortRelease: 'Veröffentlichung',
            sortPrice: 'Preis',
            filters: 'Filter',
            noFilter: 'Kein Filter',
            category: 'Kategorie',
            catPokemon: 'Pokémon',
            catTrainer: 'Trainer',
            catEnergy: 'Energie',
            type: 'Typ',
            rarity: 'Seltenheit',
            set: 'Set',
        },
        collectionModal: {
            selectCollection: 'Wähle eine Sammlung aus',
            moveCards: 'Verschiebe Karten in Sammlung ... ',
        },
        marketplaceDialog: {
            putOnMarketplace: 'Karten auf dem Marktplatz anbieten',
            puttingOnMarketplace: 'Stelle Karten auf den Marktplatz ... ',
            priceMultiplicator: 'Preismultiplikator',
            description: 'Definiere den Multiplikator, der auf alle Kartenpreise angewendet werden soll',
            confirm: 'Bestätigen',
            freeWarning: 'ACHTUNG: Mit diesem Multiplikator werden die Karten verschenkt!',
        },
        hint: 'Lange halten / Rechtsklick um mehrere Karten zu markieren',
        showingFiltered: 'Keine Karten entsprechen dem Filter | {n} Karte entspricht dem Filter | {n} Karten entsprechen dem Filter.',
        empty: 'Ziemlich leer hier. Öffne ein Paar Booster-Packs!',
        selectCards: 'Karten auswählen',
        stopSelectingCards: 'Auswahl abbrechen',
    },
    quiz: {
        info: 'Nimm an einem Quiz teil und gewinne bis zu 100 <img src="/assets/dipocaco/currency_x64.png" alt="" class="currency-icon" style="height: 1.5em"> pro Spiel!',
        info2: 'Jede Runde besteht aus {count} zufällig generierten Fragen.',
        start: 'Quiz starten',
        progress: 'Frage {done} von {from}',
        leaderboard: {
            name: 'Bestenliste',
            correct: 'Korrekt',
            questions: 'Fragen',
        },
        answers: {
            correct: 'Die korrekte Antwort ist {answer}'
        },
        solution: {
            correct: 'Richtig!',
            wrong: 'Falsch!',
            weight: '{name} wiegt {answer}kg.',
            height: '{name} ist {answer}m groß.',
            types: "Der Typ von {name} ist",
            generation: '{name} gehört Generation {generation} an',
        },
        questions: {
            name: 'Welches Pokémon ist das?',
            legendary: 'Welches ist das legendäre Pokémon?',
            baby: 'Welches ist das Baby-Pokémon?',
            weight: 'Wie schwer ist {name}?',
            types: 'Welchen Typ hat {name}?',
            height: 'Wie groß ist {name}?',
            generation: 'Welcher Generation gehört {name} an?',
            cry: 'Zu welchem Pokémon gehört dieser Ruf?',
            playCry: 'Abspielen',
        },
        result: 'Du hast {correctAnswers}/{questionsTotal} Fragen richtig beantwortet und gewinnst {payout}',
        winNotificaton: "Du gewinnst {payout} Credits ",
        nextQuestion: 'Weiter zur nächsten Frage',
        finish: 'Zeige Ergebnisse',
    },
    slot: {
        title: 'Evoli Slots',
        bet: 'Wetteinsatz',
        spin: 'Drehen',
        spinning: 'Dreht',
        fastSpin: ' Schneller drehen',
        sound: ' Ton an/aus',
        lastWin: 'Letzter Gewinn',
        noCredit: 'Nicht genug Credits',
        win: 'Du hast {win} Credits gewonnen!',
        maxBet: 'Der maximale Einsatz sind {max} Credits',
        minBet: 'Der minimale Einsatz sind 10 Credits',
    },
    trading: {
        title: 'Tauschen',
        tabs: {
            inbox: 'Eingang',
            sent: 'Ausgang',
            new: 'Neues Angebot',
            wishlist: 'Wunschliste',
        },
        received: 'Erhaltene Angebote',
        noOffersPending: 'Es sind aktuell keine Angebote ausständig',
        offeredBy: 'Angebot von',
        cardName: 'Kartenname',
        set: 'Set',
        inCollection: 'In deiner Sammlung',
        youOffered: 'Dein Gegenangebot',
        deny: 'Ablehnen',
        answer: 'Antworten',
        cancelOffer: 'Angebot abbrechen',
        sentOffers: 'Gesendete Angebote',
        noSentOffers: 'Du hast aktuell keine Angebote versendet',
        offeredTo: 'Angebot an',
        theirOffer: 'Gegenangebot',
        makeOffer: 'Mach ein Angebot',
        searchUser: 'Suche nach Username',
        offer: 'Angebot',
        yourWishlist: 'Deine Wunschliste',
        answerOffer: 'Angebot machen',
        makeOfferTo: 'Mach {name} ein Angebot',
        selectCard: 'Wähle eine Karte als Gegenangebot an {name}',
        theirWishlist: 'Karten auf deren Wunschliste',
        offerCard: 'Biete {card} an',
        notifications: {
            denyOfferBy: 'Willst du dieses Angebot von {name} wirklich ablehnen?',
            cancelOfferTo: 'Willst du das Angebot an {name} wirklich abbrechen?',
        }
    },
    social: {
        title: 'Social Feed',
        tabs: {
            following: 'Gefolgt',
            global: 'Entdecken',
            search: 'Suche',
        },
        noFollowing: 'Du folgst aktuell noch niemandem',
        onlyBoosters: 'Scheinbar gibt es aktuell nur Postings mit Booster-Öffnungen!',
        hideBoosters: 'Verstecke Booster-Öffnungen',
        searchUsers: 'Suche nach Usern',
        followers: 'Followers',
        following: 'Folgt',
        liked: 'Posting geliked',
        deleteConfirm: 'Willst du dieses Posting wirklich löschen?',
        postingDeleted: 'Posting wurde gelöscht'
    },
    search: {
        title: 'Kartensuche',
        placeholder: 'Suche nach einem Pokémon, Künster oder Set',
        highlightOwned: 'Karten in Sammlung hervorheben',
        found: '{results} Karten gefunden',
        cutResults: '(Es werden maximal 300 Ergebnisse angezeigt, bitte verfeinere Deine Suche)',
        minLength: 'Suche nach mindestens drei Zeichen',
        noResults: 'Keine Karten gefunden'
    },
    settings: {
        title: 'Einstellungen',
        chooseAvatar: 'Wähle Deinen Avatar',
        showUnknown: 'Zeige unbekannte Karten in der Gallerie',
        disableSeasonalDesigns: 'Deaktiviere Jahrzeit-Designs',
        language: 'Sprache',
        languages: {
            en: 'Englisch',
            de: 'Deutsch',
        },
        enablePush: 'Aktiviere Push-Benachrichtungen',
        logout: 'Ausloggen',
        deleteAccount: 'Lösche meinen Account',
        notifications: {
            updateAvatar: 'Avatar aktualisiert',
            pushEnabled: 'Push-Benachrichtungen aktiviert',
        }
    },
    wordle: {
        title: 'PokéWordle',
        greeting: 'Willkommen bei PokéWordle!',
        info: 'Errate den Namen eines Pokémon und verdiene Credits!',
        selectDifficulty: 'Wähle deine Schwierigkeit',
        letterCount: 'Buchstaben',
        newRound: 'Start',
        invalidSubmission: 'Kein valider Pokémon-Name',
        incorrect: 'Leider falsch!',
        correct: 'Korrekt!',
        solutionWas: 'Die Lösung war "{name}"',
        winNotificaton: "Du gewinnst {payout} Credits ",
        possibleEntries: 'Enthaltene Pokémon',
    },
    quests: {
        title: 'Heutige Quests',
        booster_openings: 'zero | Öffne {n} Boosterpack | Öffne {n} Boosterpacks',
        booster_purchases: 'zero | Kaufe {n} Boosterpack | Kaufe {n} Boosterpacks',
        card_rarity_pulls: 'Ziehe {quantity} {rarity} Karten',
        card_type_pulls: 'Ziehe {quantity} {type} Karten',
        item_purchases: {
            'booster-box': 'zero | Kaufe {n} Display | Kaufe {n} Displays',
            'booster-bundle': 'zero | Kaufe {n} Booster-Bundle | Kaufe {n} Booster-Bundles',
            'collection': 'zero | Kaufe {n} Collection | Kaufe {n} Collections',
            'duo-blister': 'zero | Kaufe {n} Duo-Blister | Kaufe {n} Duo-Blister',
            'elite-trainer-box': 'zero | Kaufe {n} Top-Trainer-Box | Kaufe {n} Top-Trainer-Boxen',
            'mini-tin': 'zero | Kaufe {n} Mini-Tin-Box | Kaufe {n} Mini-Tin-Boxen',
            'mixed-blister': 'zero | Kaufe {n} gemischten Blister | Kaufe {n} gemischte Blister',
            'quad-blister': 'zero | Kaufe {n} Quad Blister | Kaufe {n} Quad Blister',
            'single-blister': 'zero | Kaufe {n} Single Blister | Kaufe {n} Single Blister',
            'single-booster': 'zero | Kaufe {n} einzelnes Boosterpack | Kaufe {n} einzelne Boosterpacks',
            'triple-blister': 'zero | Kaufe {n} Triple Blister | Kaufe {n} Triple Blister',
        },
        trades_done: 'zero | Schließe {n} Tausch ab | Tausche {n} Male',
        quizzes_done: 'zero | Schließe ein Quiz ab | Schließe {n} Quizzes ab',
        wordles_done: 'zero | Löse {n} PokéWordle | Löse {n} PokéWordles',
        collect_success: 'Belohnungen eingesammelt!',
        collect: 'Sammle',
        collected: 'Gesammelt:',
    }
}
